import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportClaimIncentivesPage } from './report-claim-incentives.page';

const routes: Routes = [
  {
    path: '',
    component: ReportClaimIncentivesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportClaimIncentivesPageRoutingModule {}
